import axios from './axios';

// eslint-disable-next-line import/prefer-default-export
export const sendFeedbackMessage = (feedbackMessage: string) => axios.post('/feedback', { feedbackMessage });
